import Api from '../Api'

export const login = user => { return Api.post('auth/login',user)};

export const logout=() => {
    return  Api.get('auth/logout').then(res=>console.log("Logged Out successfully")).catch(err=>console.log("Logged out error"))
 }

